import React, { useEffect, useState } from "react";
import {
    PaymentElement,
    useStripe,
    useElements,
    PaymentRequestButtonElement,
} from "@stripe/react-stripe-js";
import { Spinner, Button } from 'reactstrap';
import { FaArrowRight } from "react-icons/fa";


export default function CheckoutForm(props) {
    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const [paymentRequest, setPaymentRequest] = useState();

    useEffect(() => {
        if (!stripe) {
            return;
        }

        const pr = stripe.paymentRequest({
            country: 'AU',
            currency: 'aud',
            total: {
                label: 'accountedfor.com.au',
                amount: props.total,
            },
            requestPayerName: true,
            requestPayerEmail: true,
        });

        // Check the availability of the Payment Request API.
        pr.canMakePayment().then(result => {
            if (result) {
                setPaymentRequest(pr);
            }
        });

        const clientSecret = new URLSearchParams(window.location.search).get(
            "payment_intent_client_secret"
        );
        if (!clientSecret) {
            return;
        }
        stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
            switch (paymentIntent.status) {
                case "succeeded":
                    setMessage("Payment succeeded!");
                    break;
                case "processing":
                    setMessage("Your payment is processing.");
                    break;
                case "requires_payment_method":
                    setMessage("Your payment was not successful, please try again.");
                    break;
                default:
                    setMessage("Something went wrong.");
                    break;
            }
        });
    }, [stripe]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setIsLoading(true);

       const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                // Make sure to change this to your payment completion page - duh
                return_url: props.returnURL,
            },
        });

        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.
        if (error.type === "card_error" || error.type === "validation_error") {
            setMessage(error.message);
        } else {
            setMessage("An unexpected error occured.");
        }

        setIsLoading(false);
    };

    /*
     *  Beacuse Apple Pay (hiding the credit card form)
     *  is absolutely just blowing these people's minds
     *  we are going to revert back to the credit card form
     *  to train up the Google Ads AI properly (for $ not savvy clients)
     */
    /*
    if (paymentRequest) {
        return <PaymentRequestButtonElement options={{ paymentRequest }} />
    }
    */

    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            <PaymentElement id="payment-element" />
            <div className="text-right mt-4 mb-3">
                <Button
                    id="submit"
                    type="submit"
                    color="success"
                    disabled={isLoading || !stripe || !elements}
                >
                    {isLoading
                        ? <Spinner animation="border" variant="light" size="sm" />
                        : null
                    } {props.payButtonText} <FaArrowRight />
                </Button>
            </div>
            {/* Show any error or success messages */}
            {message && <div id="payment-message">{message}</div>}
        </form>
    );
}